import get from "lodash.get";
import React, { FC } from "react";
import {
	useController,
	useFormContext,
	useFormState,
	useWatch
} from "react-hook-form";

interface Props {
	stepNumber: number;
	order: number;
}

const SelectStep: FC<Props> = ({ stepNumber, order }) => {
	const { control } = useFormContext<BannerFormState>();

	const placeholder = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.placeholder`
	});

	const options = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.selectOptions`
	});

	const { field } = useController({
		name: `steps.${stepNumber - 1}.fields.${order - 1}.givenAnswer`,
		control,
		rules: {
			required: true
		}
	});

	const { errors } = useFormState({ control });

	const isAnswerInvalid = Boolean(
		get(errors, `steps[${stepNumber - 1}].fields[${order - 1}]`, null)
	);

	return (
		<select
			aria-label={`step-${stepNumber}-order-${order}`}
			className={[
				"w-full px-3 py-2 text-sm bg-white rounded-md border",
				isAnswerInvalid ? "border-destructive" : "border-transparent",
				"focus:outline-none focus:ring-2 focus:ring-ring"
			].join(" ")}
			{...field}
		>
			<option value="">{placeholder}</option>
			{options &&
				options.map((option) => (
					<option
						aria-label="select-option"
						key={option.value}
						value={option.value}
					>
						{option.name}
					</option>
				))}
		</select>
	);
};

export default SelectStep;
